import { Link } from "react-router-dom";
import { BOM } from "../../../services/definedMethod";

/*!*******************************************************************************!
  !*** FX RATE SETUP API CONFIG                                                       ***!
  \*******************************************************************************/
export const fxRateSetupAPI = {
  // Charges
  FxRateTypes: BOM.baseUrl("fxratetypes"),
  Currencies: BOM.baseUrl("currencies"),
  FxRates: BOM.baseUrl("fxrates"),
};

/*!*******************************************************************************!
  !*** FX RATE SETUP LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const fxRateSetupLabel = {
  manageFxRate: "Manage FX Rate",
  rateSetupDetail: "Rate Setup Detail",
  currencyCode1: "Currency Code 1",
  currencyCode2: "Currency Code 2",
  conversionType: "Conversion Type",
  conversionCurrency: "Conversion Currency",
  rateDate: "Rate Date",
  rateType: "Rate Type",
  midRate: "Mid Rate",
  buyRate: "Buy Rate",
  fxRateSetUp: "FX Rate Setup",
  newFxRateMsg: "FX Rate was successfully created",
  saleRate: "Sale Rate",
  authStatus: "Auth Status",
  active: "Active",
  saleSpread: "Sale Spread",
  buySpread: "Buy Spread",
  newFXRate: "New FX Rate",
  editFxRate: "Edit FX Rate",
  editFXRate: "FX Rate was successfully edited",
  currency: "Currency",
  active: "Active",
  generalInfo: "General Information",
};

/*!*******************************************************************************!
    !*** FX RATE SETUP STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const fxRateSetupStatic = {
  detailFxRateItems: [
    { title: <Link to="/prd0602">{fxRateSetupLabel.manageFxRate}</Link> },
    { title: fxRateSetupLabel.rateSetupDetail },
  ],
  newFxRateItems: [
    { title: <Link to="/prd0602">{fxRateSetupLabel.manageFxRate}</Link> },
    { title: fxRateSetupLabel.newFXRate },
  ],
  editFxRateItems: [
    { title: <Link to="/prd0602">{fxRateSetupLabel.manageFxRate}</Link> },
    { title: fxRateSetupLabel.editFxRate },
  ],
};





/*!*******************************************************************************!
  !*** FX RATE TYPE SETUP API CONFIG                                                       ***!
  \*******************************************************************************/
export const fxRateTypeSetupAPI = {
  FxRateTypes: BOM.baseUrl("fxratetypes"),
};

/*!*******************************************************************************!
  !*** FX RATE TYPE SETUP LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const fxRateTypeSetupLabel = {
  fxRateTypeSetup: "FX Rate Type Setup",
  newFXRateType: "New FX Rate Type",
  manageFxRateType: "Manage FX Rate Type",
  rateTypeSetupDetail: "Rate Type Setup Detail",
  code : "Rate Type",
  name: "Description",
  status: "Active Status",
  editFxRateType: "Edit FX Rate Type",
  editFXRateTypeMsg: "FX Rate Type was successfully edited",
  newFxRateTypeMsg: "FX Rate Type was successfully created",
  active: "Active",
  generalInfo: "General Information",
};

/*!*******************************************************************************!
    !*** FX RATE TYPE SETUP STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const fxRateTypeSetupStatic = {
  FXRateTypeSetupItems: [{ title: fxRateTypeSetupLabel.fxRateTypeSetup }],
  newFxRateTypeItems: [
    { title: <Link to="/prd0601">{fxRateTypeSetupLabel.manageFxRateType}</Link> },
    { title: fxRateTypeSetupLabel.newFXRateType },
  ],
  detailFxRateTypeItems: [
    { title: <Link to="/prd0601">{fxRateTypeSetupLabel.manageFxRateType}</Link> },
    { title: fxRateTypeSetupLabel.rateTypeSetupDetail },
  ],
  editFxRateTypeItems: [
    { title: <Link to="/prd0601">{fxRateTypeSetupLabel.manageFxRateType}</Link> },
    { title: fxRateTypeSetupLabel.editFxRateType },
  ],
};